/**
 * Swiper - slider plugin
 *
 * @author Matt Haynes <mattgh9152@gmail.com>
 * @package Gambling.com
 */

import Swiper from 'swiper/bundle';

const godparentsSlider = () => {
    // configure Swiper to use modules
    const mySwiper = new Swiper('.swiper-container-godparents', {
        speed: 400,
        spaceBetween: 100,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next-godparents',
            prevEl: '.swiper-button-prev-godparents',
        },
        pagination: {
            el: '.swiper-pagination-godparents',
        },
    });

    mySwiper.on('slideChange', () => {
        console.log('mySwiper: ', mySwiper);
        // console.log('mySwiper active index: ', mySwiper.activeIndex);
        console.log('mySwiper real index: ', mySwiper.realIndex);
    });
};

export default godparentsSlider;
